<template>
	<div class="conteudo">
		<fl-cabecalho-cadastro
			:id="form.id"
			@volta-cadastro="$emit('volta-lista')"
			@print-relatorio="clickPrint"
			v-if="menu == false"
		/>

		<fl-dados-cadastrais
			class="no-print"
			ref="cadastro_usuario"
			:menu="menu"
			:existe-trigrama="true"
			@cpf-validado="(value) => handleCpf(value)"
			@form-cadastro="formDadosCadastrais"
			:orgaos="orgaos"
			:habilita-login="habilitaLogin"
			:token="token"
		/>

		<flUsuarioOvn
			v-if="_getPrivilegio(332)"
			class="no-print"
			ref="dados_ovn"
			@dados-ovn="dadosOVN"
		/>

		<fl-acesso-sistema
			class="no-print"
			ref="acesso_sistema"
			@getCPF="$refs.cadastro_usuario.verificarSeExisteCPF()"
			@dados-acesso-sistema="dadosAcessoSistema"
			:menu="menu"
			:token="token"
			:perfis="perfis"
			:setores="setores"
		/>

		<div class="no-print">
			<fl-cliente-siga
				v-if="_idCliente == 10 || _idCliente == 33"
				ref="usuario"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
				:bases="bases"
				:estatal="estatal"
			/>
			<fl-cliente-ibama
				v-if="_idCliente == 5"
				ref="usuario"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
			/>
			<fl-cliente-alagoas
				v-if="_idCliente == 1"
				ref="usuario"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
			/>
			<fl-cliente-bahia
				v-if="_idCliente == 8"
				ref="usuario"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
			/>

			<fl-cliente-vale
				v-if="_idCliente == 25"
				ref="usuario"
				@seta-dados="
					(_form) => {
						form.pais = _form.pais
						form.localizacao = _form.localizacao
						form.companhia = _form.companhia
						form.job_level = _form.job_level
						form.centro_custo = _form.centro_custo
						form.status_funcionario = _form.status_funcionario
						form.unidade_negocio = _form.unidade_negocio
						form.estado = _form.estado
						form.job_role = _form.job_role
					}
				"
			/>

			<fl-cliente-piquiatuba
				v-if="
					_idCliente == 9 ||
					_idCliente == 18 ||
					_idCliente == 30 ||
					_idCliente == 38 ||
					_idCliente == 36 ||
					_idCliente == 41 ||
					_idCliente == 43 ||
					_idCliente == 47 ||
					_idCliente == 50 ||
					_idCliente == 58 ||
					_idCliente == 60 ||
					_idCliente == 62 ||
					_idCliente == 65 ||
					_idCliente == 71
				"
				ref="usuario"
				:id="form.id"
				@dados-usuario="carregaForm"
				:menu="menu"
				:postos="postos"
				:bases="bases"
				:cargos="cargos"
				:guarnicoes="guarnicoes"
				:estatal="estatal"
				:orgaos-apoiados="orgaosApoiados"
				:orgaos="orgaos"
				:funcoes="funcoes"
				:fabricantes="fabricantes"
				:habilitacoes="habilitacoes"
				:licencas="licencas"
				:modelos="modelos"
			/>
		</div>

		<div class="print">
			<flPrintPiquiatuba
				ref="print"
				:cargos="cargos"
				:bases="bases"
				:funcoes="funcoes"
				:postos="postos"
				:fabricantes="fabricantes"
				:habilitacoes="habilitacoes"
				:licencas="licencas"
				:modelos="modelos"
			/>
		</div>

		<hr />
		<div class="no-print row" style="margin-bottom: 10px">
			<div class="col-xs-6">
				<button
					class="btn btn-danger pull-left"
					:class="{'col-xs-3': !_isMobile}"
					@click="modalDesativarUsuario()"
					v-if="form.id != 0 && menu == false && form.status == 1"
				>
					<i class="fa fa-fw fa-trash-o"></i>
					{{ _traducao('global', 'desativar').toUpperCase() }}
				</button>
				<button
					class="btn no-print btn-success"
					:class="{'col-xs-3': !_isMobile}"
					v-if="form.status == 0 && form.id != 0"
					style="margin-right: 20px"
					@click="modalAtivarUsuario()"
				>
					<i class="fa fa-check-circle fa-fw"></i>
					{{ _traducao('global', 'ativar').toUpperCase() }}
				</button>
			</div>
			<div class="col-xs-6">
				<button
					class="btn btn-success pull-right"
					:class="{'col-xs-3': !_isMobile}"
					@click="clickSalvar()"
				>
					<span v-if="form.id != 0">
						<i class="fa fa-fw fa-check"></i>
						{{ _traducao('global', 'atualizar').toUpperCase() }}
					</span>
					<span v-if="form.id == 0">
						<i class="fa fa-fw fa-check"></i>
						{{ _traducao('global', 'salvar').toUpperCase() }}
					</span>
				</button>
			</div>
		</div>

		<fl-desativar-usuario
			class="no-print"
			:form="form"
			ref="desativar_usuario"
			@excluido="usuarioExcluirOuAtivar"
		/>
		<fl-ativar-usuario
			class="no-print"
			:form="form"
			ref="ativar_usuario"
			@ativado="usuarioAtivar"
		/>
	</div>
</template>
<script>
import flCabecalhoCadastro from './cabecalho/main.vue'
import flDadosCadastrais from './componentes/dados-cadastrais.vue'
import flAcessoSistema from './componentes/acesso-sistema.vue'
import flDesativarUsuario from './componentes/modal/modal-desativar-usuario.vue'
import flAtivarUsuario from './componentes/modal/modal-ativar-usuario.vue'
import flDadosCiv from './componentes/dados-civ.vue'
import flUsuarioOvn from './componentes/usuario-ovn.vue'

import flClienteSiga from './mg-siga/cadastro.vue'
import flClienteIbama from './ibama/cadastro.vue'
import flClienteBahia from './cm-bahia/cadastro.vue'
import flClienteAlagoas from './alagoas/cadastro.vue'
import flClienteVale from './vale/cadastro.vue'
import flClientePMES from './pm-es/cadastro.vue'
import flClientePiquiatuba from './piquiatuba/cadastro.vue'

import flPrintPiquiatuba from './piquiatuba/print.vue'

export default {
	components: {
		flCabecalhoCadastro,
		flDadosCadastrais,
		flAcessoSistema,
		flDesativarUsuario,
		flAtivarUsuario,
		flDadosCiv,
		flUsuarioOvn,

		flClienteSiga,
		flClienteIbama,
		flClienteAlagoas,
		flClienteBahia,
		flClienteVale,
		flClientePMES,
		flClientePiquiatuba,

		flPrintPiquiatuba
	},

	props: {
		bases: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		carregaInformacoes: {
			default: true,
			type: Boolean,
			require: false
		},
		estatal: {
			type: Boolean,
			required: true,
			default: false
		},
		orgaosApoiados: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		cargos: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		orgaos: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		perfis: {
			default() {
				return []
			},
			type: Array,
			required: true
		}
	},

	data() {
		return {
			tipo: '',
			menu: false,
			exibe_modal_desativar: false,
			guarnicoes: [],
			postos: [],
			setores: [],
			funcoes: [],
			fabricantes: [],
			habilitacoes: [],
			licencas: [],
			modelos: [],
			token: null,

			dadosForm: {},

			form: {
				acesso_sistema: 1,
				alergia: '',
				anac: '',
				outro: '',
				assinatura: '',
				atualiza_assinatura: '0',
				atualiza_senha: '0',
				bairro: '',
				bairro_emergencia: '',
				bairro_funcional: '',
				cargo: '',
				id_posto_graduacao: '',
				celular: '',
				celular2: '',
				celular_emergencia: '',
				cep: '',
				cep_emergencia: '',
				cep_funcional: '',
				certificado_icp: '0',
				cidade: '',
				cidade_emergencia: '',
				cidade_funcional: '',
				codigo_anac: '',
				complemento: '',
				complemento_emergencia: '',
				complemento_funcional: '',
				cpf: '',
				crea: '',
				data_nascimento: '',
				departamento: '',
				email: '',
				esta_guarnicao: 0,
				estado: '',
				estado_emergencia: '',
				estado_funcional: '',
				fator_rh: '',
				foto: '',
				foto_antiga: '',
				grau_emergencia: '',
				guarnicao: '',
				id: 0,
				id_guarnicao: 0,
				id_perfil: '',
				id_pessoa: '',
				id_posto_graduacao: '',
				id_usuario: window.$sessao.getId(),
				id_usuario_cargo: '',
				id_usuario_departamento: '',
				identidade: '',
				login: '',
				logradouro: '',
				logradouro_emergencia: '',
				logradouro_funcional: '',
				masp: '',
				matricula: '',
				nome: '',
				nome_emergencia: '',
				nome_guerra: '',
				numero: '',
				numero_emergencia: '',
				numero_funcional: '',
				numero_ordem: '',
				senha: '',
				senha_icp: '',
				status: 1,
				telefone: '',
				telefone2: '',
				telefone_emergencia: '',
				tipo_certificado: '',
				tipo_sanguineo: '',
				trigrama: '',
				validade_exame: '',
				pais: '',
				localizacao: '',
				companhia: '',
				job_level: '',
				centro_custo: '',
				status_funcionario: '',
				unidade_negocio: '',
				estado: '',
				job_role: '',
				horas_voo: '',
				horas_voo_segundo: '',
				horas_inicial_ovn: '',
				minutos_inicial_ovn: '',
				data_horas_voo: '',
				data_horas_voo_segundo: '',
				data_ultimo_voo_ovn: '',
				rg: '',
				sexo: '',
				ctps: '',
				nome_pai: '',
				nome_mae: '',
				nacionalidade: '',
				naturalidade: '',
				estado_civil: '',
				nome_tratamento: '',
				escolaridade: '',
				tipo_guarnicao: '',
				peso: '',
				id_orgao: '',
				id_orgao_apoiado: '',
				base_contratual: [],
				funcao: [],
				vencimentos: [],
				id_base: '',
				sgpe: '',
				estado_conselho: '',
				num_registro: '',
				banco: '',
				codigo_banco: '',
				codigo_agencia: '',
				numero_conta: ''
			},
			habilitaLogin: false,
		}
	},

	created() {
		this._getParametro(12).then((valor) => (this.habilitaLogin = Boolean(Number(valor))))
		if (this.carregaInformacoes) {
			this.carregaDados(null)
		}
	},

	methods: {
		handleCpf(cpf) {
			let cpfFormatado = cpf.replace(/\D/g, '')
			this.$refs.acesso_sistema.preencheLogin(cpfFormatado)
		},
		novo(objetoParaSerCriado) {
			this.menu = objetoParaSerCriado.menu
		},
		usuarioExcluirOuAtivar(usuarioParaSerExcluido) {
			this.$emit('atualiza-lista-usuarios', usuarioParaSerExcluido)
		},

		usuarioAtivar(usuarioAtivado) {
			this.form.perfis = []
			this.clickSalvar()
			this.$emit('atualiza-lista-usuarios', usuarioAtivado)
		},

		editar(objetoParaSerEditado) {
			this.menu = objetoParaSerEditado.menu
			this.carregaDadosUser(objetoParaSerEditado)
		},

		carregaUsuarioLogado(objetoParaSerCarregadoJuntoAoUsuario) {
			this.menu = objetoParaSerCarregadoJuntoAoUsuario.menu

			if (!this.isNil(objetoParaSerCarregadoJuntoAoUsuario.token)) {
				this.token = objetoParaSerCarregadoJuntoAoUsuario.token
				this.carregaDados(this.token)
			}

			this.$nextTick(() => {
				this.carregaDadosUser(objetoParaSerCarregadoJuntoAoUsuario)
			})
		},

		// RECEBES OS DADOS DO COMPONENTE CADASTRO
		carregaForm(dados) {
			this.dadosForm = dados.form
		},

		/* Conferindo se o valor é nulo ou undefined */

		isNil(value) {
			return value === null || value === undefined
		},

		carregaDadosUser(objetoParaSerCarregado) {
			this.form.id = objetoParaSerCarregado.id

			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})

			this._httpGet(
				'/Usuario/editar/' + this.form.id,
				(retorno) => {
					window.bus.$emit('load-out')
					if (retorno._request && retorno._status) {
						this.carregaDadosUsuario(retorno)

						if (this.$refs.dados_ovn) {
							this.$refs.dados_ovn.editar(this.form)
						}

						this.$nextTick(() => {
							this.$refs.cadastro_usuario.editar(this.form)
							this.$refs.acesso_sistema.editar(this.form)
							this.$refs.dados_civ.editar(this.form)
							this.$refs.dados_adicionais.editar(this.form)
						})

						if (
							window.$cliente.get('id') == '1' ||
							window.$cliente.get('id') == '5' ||
							window.$cliente.get('id') == '9' ||
							window.$cliente.get('id') == '10' ||
							window.$cliente.get('id') == '18' ||
							window.$cliente.get('id') == '25' ||
							window.$cliente.get('id') == '30' ||
							window.$cliente.get('id') == '33' ||
							window.$cliente.get('id') == '36' ||
							window.$cliente.get('id') == '38' ||
							window.$cliente.get('id') == '41' ||
							window.$cliente.get('id') == '43' ||
							window.$cliente.get('id') == '47' ||
							window.$cliente.get('id') == '50' ||
							window.$cliente.get('id') == '58' ||
							window.$cliente.get('id') == '60' ||
							window.$cliente.get('id') == '62' ||
							window.$cliente.get('id') == '65' ||
							window.$cliente.get('id') == '71'
						) {
							this.$refs.usuario.editar(this.form)
						}
					}
				},
				this.token
			)
		},

		carregaDadosUsuario(dados) {
			this.form.novo_usuario =
				this._trataRetornoVazio(dados.usuario.novo_usuario) == ''
					? '0'
					: this._trataRetornoVazio(dados.usuario.novo_usuario)
			this.form.foto = this._trataRetornoVazio(dados.usuario.foto)
			this.form.foto_antiga = this._trataRetornoVazio(dados.usuario.foto_antiga)
			this.form.anac = this._trataRetornoVazio(dados.usuario.codigo_anac)
			this.form.celular = this._trataRetornoVazio(dados.usuario.celular)
			this.form.celular2 = this._trataRetornoVazio(dados.usuario.celular2)
			this.form.codigo_anac = this._trataRetornoVazio(dados.usuario.codigo_anac)
			this.form.cpf = this._trataRetornoVazio(dados.usuario.cpf)
			this.form.autoridade = this._trataRetornoVazio(dados.usuario.autoridade)
			this.form.email = this._trataRetornoVazio(dados.usuario.email)
			this.form.nome = this._trataRetornoVazio(dados.usuario.nome)
			this.form.id_orgao = this._trataRetornoVazio(dados.usuario.id_orgao)
			this.form.id_orgao_apoiado = this._trataRetornoVazio(
				dados.usuario.id_orgao_apoiado
			)
			this.form.telefone = this._trataRetornoVazio(dados.usuario.telefone)
			this.form.outro = this._trataRetornoVazio(dados.usuario.outro)
			this.form.telefone2 = this._trataRetornoVazio(dados.usuario.telefone2)
			this.form.trigrama = this._trataRetornoVazio(dados.usuario.trigrama)
			this.form.matricula_prontos = this._trataRetornoVazio(
				dados.usuario.matricula_prontos
			)
			this.form.crea = this._trataRetornoVazio(dados.usuario.crea)

			this.form.banco = this._trataRetornoVazio(dados.usuario.banco)
			this.form.codigo_banco = this._trataRetornoVazio(
				dados.usuario.codigo_banco
			)
			this.form.codigo_agencia = this._trataRetornoVazio(
				dados.usuario.codigo_agencia
			)
			this.form.numero_conta = this._trataRetornoVazio(
				dados.usuario.numero_conta
			)

			if (this._idCliente == 41 || this._idCliente == 38) {
				this.form.data_nascimento = this._trataRetornoVazio(
					this._SQLDateToDate(
						dados.usuario.data_nascimento,
						window.$sessao.getDateFormat()
					)
				)
			}
			this.form.rg = this._trataRetornoVazio(dados.usuario.rg)
			this.form.sexo = this._trataRetornoVazio(dados.usuario.sexo)
			this.form.ctps = this._trataRetornoVazio(dados.usuario.ctps)
			this.form.nome_pai = this._trataRetornoVazio(dados.usuario.nome_pai)
			this.form.nome_mae = this._trataRetornoVazio(dados.usuario.nome_mae)
			this.form.nacionalidade = this._trataRetornoVazio(
				dados.usuario.nacionalidade
			)
			this.form.naturalidade = this._trataRetornoVazio(
				dados.usuario.naturalidade
			)
			this.form.estado_civil = this._trataRetornoVazio(
				dados.usuario.estado_civil
			)
			this.form.nome_tratamento = this._trataRetornoVazio(
				dados.usuario.nome_tratamento
			)
			this.form.escolaridade = this._trataRetornoVazio(
				dados.usuario.escolaridade
			)
			this.form.tipo_guarnicao = this._trataRetornoVazio(
				dados.usuario.tipo_guarnicao
			)
			if (dados.usuario.peso) {
				dados.usuario.peso = Number(dados.usuario.peso).toFixed(2)
			}
			this.form.peso = this._trataRetornoVazio(dados.usuario.peso)
			this.form.id_base = this._trataRetornoVazio(dados.usuario.id_base)
			this.form.horas_inicial_ovn = dados.usuario.horas_inicial_ovn
			this.form.minutos_inicial_ovn = dados.usuario.minutos_inicial_ovn
			this.form.data_ultimo_voo_ovn = this._trataRetornoVazio(
				window
					.moment(dados.usuario.data_ultimo_voo_ovn, 'YYYY-MM-DD')
					.format('DD/MM/YYYY')
			)

			this.form.login = this._trataRetornoVazio(dados.usuario.login)
			this.carregarVencimentos(Number(dados.usuario.id_usuario))
			this.carregaAcessoAoSistema(dados)
		},

		carregaAcessoAoSistema(dados) {
			this.form.atualiza_assinatura = this._trataRetornoVazio(
				dados.usuario.atualiza_assinatura
			)
			this.form.atualiza_senha = this._trataRetornoVazio(
				dados.usuario.atualiza_senha
			)
			this.form.certificado_icp = this._trataRetornoVazio(
				dados.usuario.certificado_icp
			)
			this.form.login = this._trataRetornoVazio(dados.usuario.login)
			this.form.perfis = dados.perfis
			this.form.setores = dados.usuario.setores
			if (this.form.perfis.length == 1) {
				if (this.form.perfis[0].id == 21) {
					this.form.tipo = 'S'
				} else {
					this.form.tipo = 'O'
				}
			} else {
				this.form.tipo = 'O'
			}

			this.form.acesso_sistema = this.form.perfis.length == 0 ? '0' : '1'
			this.carregaEndereco(dados)
		},

		carregaEndereco(dados) {
			this.form.bairro = this._trataRetornoVazio(dados.usuario.bairro)
			this.form.bairro_emergencia = this._trataRetornoVazio(
				dados.usuario.bairro_emergencia
			)
			this.form.bairro_funcional = this._trataRetornoVazio(
				dados.usuario.bairro_funcional
			)
			this.form.cep = this._trataRetornoVazio(dados.usuario.cep)
			this.form.cep_emergencia = this._trataRetornoVazio(
				dados.usuario.cep_emergencia
			)
			this.form.cep_funcional = this._trataRetornoVazio(
				dados.usuario.cep_funcional
			)
			this.form.cidade = this._trataRetornoVazio(dados.usuario.cidade)
			this.form.cidade_emergencia = this._trataRetornoVazio(
				dados.usuario.cidade_emergencia
			)
			this.form.cidade_funcional = this._trataRetornoVazio(
				dados.usuario.cidade_funcional
			)
			this.form.complemento = this._trataRetornoVazio(dados.usuario.complemento)
			this.form.complemento_emergencia = this._trataRetornoVazio(
				dados.usuario.complemento_emergencia
			)
			this.form.complemento_funcional = this._trataRetornoVazio(
				dados.usuario.complemento_funcional
			)
			this.form.estado = this._trataRetornoVazio(dados.usuario.estado)
			this.form.estado_emergencia = this._trataRetornoVazio(
				dados.usuario.estado_emergencia
			)
			this.form.estado_funcional = this._trataRetornoVazio(
				dados.usuario.estado_funcional
			)
			this.form.logradouro = this._trataRetornoVazio(dados.usuario.logradouro)
			this.form.logradouro_emergencia = this._trataRetornoVazio(
				dados.usuario.logradouro_emergencia
			)
			this.form.logradouro_funcional = this._trataRetornoVazio(
				dados.usuario.logradouro_funcional
			)
			this.form.numero = this._trataRetornoVazio(dados.usuario.numero)
			this.form.numero_emergencia = this._trataRetornoVazio(
				dados.usuario.numero_emergencia
			)
			this.form.numero_funcional = this._trataRetornoVazio(
				dados.usuario.numero_funcional
			)
			this.form.interno = this._trataRetornoVazio(dados.usuario.interno)

			this.form._controleAdicional = this.form.cep == '' ? false : true

			this.carregaTipoUsuario(dados)
		},

		carregaTipoUsuario(dados) {
			this.form.masp = this._trataRetornoVazio(dados.usuario.masp)

			if (this._idCliente != 41 && this._idCliente != 38) {
				this.form.data_nascimento = this._trataRetornoVazio(
					this._SQLDateToDate(
						dados.usuario.data_nascimento,
						window.$sessao.getDateFormat()
					)
				)
			}
			this.form.cargo = this._trataRetornoVazio(dados.usuario.cargo)
			this.form.nome_guerra = this._trataRetornoVazio(dados.usuario.nome_guerra)
			this.form.id_posto_graduacao = this._trataRetornoVazio(
				dados.usuario.id_posto_graduacao
			)
			this.form.sgpe = this._trataRetornoVazio(dados.usuario.sgpe)

			let bases = dados.usuario.base_contratual
			if (Array.isArray(bases)) {
				bases = bases.map((base) => {
					base.data = this._SQLDateToDate(
						base.data,
						window.$sessao.getDateFormat()
					)
					base.excluir = 0
					return base
				})
			}

			let funcoes = dados.usuario.funcao
			if (Array.isArray(funcoes)) {
				funcoes = funcoes.map((funcao) => {
					funcao.data = this._SQLDateToDate(
						funcao.data,
						window.$sessao.getDateFormat()
					)
					funcao.excluir = 0
					return funcao
				})
			}
			this.form.base_contratual = this._trataRetornoVazio(bases)
			this.form.funcao = this._trataRetornoVazio(funcoes)
			this.form.estado_conselho = this._trataRetornoVazio(dados.estado_conselho)
			this.form.num_registro = this._trataRetornoVazio(dados.num_registro)

			this.carregaDadosEmergencia(dados)
		},

		carregaDadosEmergencia(dados) {
			this.form.tipo_sanguineo = this._trataRetornoVazio(
				dados.usuario.tipo_sanguineo
			)
			this.form.fator_rh = this._trataRetornoVazio(dados.usuario.fator_rh)
			this.form.alergia = this._trataRetornoVazio(dados.usuario.alergia)
			this.form.nome_emergencia = this._trataRetornoVazio(
				dados.usuario.nome_emergencia
			)
			this.form.grau_emergencia = this._trataRetornoVazio(
				dados.usuario.grau_emergencia
			)
			this.form.telefone_emergencia = this._trataRetornoVazio(
				dados.usuario.telefone_emergencia
			)
			this.form.celular_emergencia = this._trataRetornoVazio(
				dados.usuario.celular_emergencia
			)

			this.carregaDadosAdicionais(dados)
		},

		carregaDadosAdicionais(dados) {
			this.form.identidade = this._trataRetornoVazio(dados.usuario.identidade)
			this.form.departamento = this._trataRetornoVazio(
				dados.usuario.departamento
			)
			this.form.guarnicao = this._trataRetornoVazio(
				dados.usuario.tipo_guarnicao
			)
			this.form.matricula = this._trataRetornoVazio(dados.usuario.matricula)
			this.form.tipo_guarnicao = this._trataRetornoVazio(
				dados.usuario.tipo_guarnicao
			)
			this.form.tipo_certificado = this._trataRetornoVazio(
				dados.usuario.id_tipo_certificado
			)
			this.form.validade_exame = this._trataRetornoVazio(
				this._SQLDateToDate(
					dados.usuario.validade_exame,
					window.$sessao.getDateFormat()
				)
			)
			this.form.id_guarnicao = this._trataRetornoVazio(
				dados.usuario.id_guarnicao
			)
			this.form.id_pessoa = this._trataRetornoVazio(dados.usuario.id_pessoa)
			this.form.id_usuario = this._trataRetornoVazio(dados.usuario.id_usuario)
			this.form.id_usuario_cargo = this._trataRetornoVazio(
				dados.usuario.id_usuario_cargo
			)
			this.form.id_posto_graduacao = this._trataRetornoVazio(
				dados.usuario.id_posto_graduacao
			)
			this.form.sgpe = this._trataRetornoVazio(dados.usuario.sgpe)

			this.form.banco = this._trataRetornoVazio(dados.usuario.banco)
			this.form.codigo_banco = this._trataRetornoVazio(
				dados.usuario.codigo_banco
			)
			this.form.codigo_agencia = this._trataRetornoVazio(
				dados.usuario.codigo_agencia
			)
			this.form.numero_conta = this._trataRetornoVazio(
				dados.usuario.numero_conta
			)

			this.form.id_usuario_departamento = this._trataRetornoVazio(
				dados.usuario.id_usuario_departamento
			)

			this.form.numero_ordem = this._trataRetornoVazio(
				dados.usuario.numero_ordem
			)
			this.form.status = this._trataRetornoVazio(dados.usuario.status)
			this.form.esta_guarnicao = this.form.tipo_guarnicao == '' ? '0' : '1'
			this.form.estado_conselho = this._trataRetornoVazio(
				dados.usuario.estado_conselho
			)
			this.form.num_registro = this._trataRetornoVazio(
				dados.usuario.num_registro
			)

			const objeto_cargo = this.cargos.find(
				(cargo) => dados.usuario.cargo == cargo.id
			)

			if (objeto_cargo) {
				this.form.sigla_conselho = this._trataRetornoVazio(
					objeto_cargo.sigla_conselho
				)
			}

			this.carregaIAMDadosVale(dados)
		},

		carregaIAMDadosVale(dados) {
			this.form.pais = this._trataRetornoVazio(dados.usuario.pais)
			this.form.localizacao = this._trataRetornoVazio(dados.usuario.localizacao)
			this.form.companhia = this._trataRetornoVazio(dados.usuario.companhia)
			this.form.job_level = this._trataRetornoVazio(dados.usuario.job_level)
			this.form.centro_custo = this._trataRetornoVazio(
				dados.usuario.centro_custo
			)
			this.form.status_funcionario = this._trataRetornoVazio(
				dados.usuario.status_funcionario
			)
			this.form.unidade_negocio = this._trataRetornoVazio(
				dados.usuario.unidade_negocio
			)
			this.form.estado = this._trataRetornoVazio(dados.usuario.estado)
			this.form.job_role = this._trataRetornoVazio(dados.usuario.job_role)

			//this.carregaDadosCiv(dados)
		},

		carregaDadosCiv(dados) {
			this.form.horas_voo = this._trataRetornoVazio(dados.usuario.horas_voo)
			this.form.horas_voo_segundo = this._trataRetornoVazio(
				dados.usuario.horas_voo_segundo
			)
			this.form.data_horas_voo = this._trataRetornoVazio(
				this._SQLDateToDate(
					dados.usuario.data_horas_voo,
					window.$sessao.getDateFormat()
				)
			)
			this.form.data_horas_voo_segundo = this._trataRetornoVazio(
				this._SQLDateToDate(
					dados.usuario.data_horas_voo_segundo,
					window.$sessao.getDateFormat()
				)
			)
		},

		getPerfilPorId(id) {
			this.perfis.find((perfil) => {
				return perfil.id === id
			})
		},

		setaDadosCadastrais() {
			if (!this.isNil(this.dados_cadastrais)) {
				this.form.id = this._trataRetornoVazio(this.dados_cadastrais.id)
				this.form.celular = this._trataRetornoVazio(
					this.dados_cadastrais.celular
				)
				this.form.celular2 = this._trataRetornoVazio(
					this.dados_cadastrais.celular2
				)
				this.form.codigo_anac = this._trataRetornoVazio(
					this.dados_cadastrais.codigo_anac
				)
				this.form.anac = this._trataRetornoVazio(
					this.dados_cadastrais.codigo_anac
				)
				this.form.cpf = this._trataRetornoVazio(this.dados_cadastrais.cpf)
				this.form.email = this._trataRetornoVazio(this.dados_cadastrais.email)
				this.form.foto = this._trataRetornoVazio(this.dados_cadastrais.foto)
				this.form.foto_antiga = this._trataRetornoVazio(
					this.dados_cadastrais.foto_antiga
				)
				this.form.outro = this._trataRetornoVazio(this.dados_cadastrais.outro)
				this.form.id_usuario = this._trataRetornoVazio(
					this.dados_cadastrais.id_usuario
				)
				this.form.nome = this._trataRetornoVazio(this.dados_cadastrais.nome)
				this.form.telefone = this._trataRetornoVazio(
					this.dados_cadastrais.telefone
				)
				this.form.trigrama = this._trataRetornoVazio(
					this.dados_cadastrais.trigrama
				)
				this.form.crea = this._trataRetornoVazio(this.dados_cadastrais.crea)

				if (this._idCliente == 41 || this._idCliente == 38) {
					this.form.data_nascimento = this._trataRetornoVazio(
						this._dateToDateSQL(
							this.dados_cadastrais.data_nascimento,
							window.$sessao.getDateFormat()
						)
					)
				} else {
					this.form.id_orgao = this._trataRetornoVazio(
						this.dados_cadastrais.id_orgao
					)
				}
				if (this.dadosForm.dados_adicionais) {
					this.form.id_orgao_apoiado = this._trataRetornoVazio(
						this.dadosForm.dados_adicionais.id_orgao_apoiado
					)
				}
				this.form.rg = this._trataRetornoVazio(this.dados_cadastrais.rg)
				this.form.sexo = this._trataRetornoVazio(this.dados_cadastrais.sexo)
				this.form.ctps = this._trataRetornoVazio(this.dados_cadastrais.ctps)
				this.form.nome_pai = this._trataRetornoVazio(
					this.dados_cadastrais.nome_pai
				)
				this.form.nome_mae = this._trataRetornoVazio(
					this.dados_cadastrais.nome_mae
				)
				this.form.nacionalidade = this._trataRetornoVazio(
					this.dados_cadastrais.nacionalidade
				)
				this.form.naturalidade = this._trataRetornoVazio(
					this.dados_cadastrais.naturalidade
				)
				this.form.estado_civil = this._trataRetornoVazio(
					this.dados_cadastrais.estado_civil
				)
				this.form.nome_tratamento = this._trataRetornoVazio(
					this.dados_cadastrais.nome_tratamento
				)
				this.form.escolaridade = this._trataRetornoVazio(
					this.dados_cadastrais.escolaridade
				)
				this.form.tipo_guarnicao = this._trataRetornoVazio(
					this.dados_cadastrais.tipo_guarnicao
				)
				this.form.peso = this._trataRetornoVazio(this.dados_cadastrais.peso)
				this.form.id_base = this._trataRetornoVazio(
					this.dados_cadastrais.id_base
				)
			}
		},

		setaDadosCiv() {
			if (!this.isNil(this.dados_civ)) {
				this.form.horas_voo = this._trataRetornoVazio(this.dados_civ.horas_voo)
				this.form.horas_voo_segundo = this._trataRetornoVazio(
					this.dados_civ.horas_voo_segundo
				)
				this.form.data_horas_voo = this._trataRetornoVazio(
					this._dateToDateSQL(
						this.dados_civ.data_horas_voo,
						window.$sessao.getDateFormat()
					)
				)
				this.form.data_horas_voo_segundo = this._trataRetornoVazio(
					this._dateToDateSQL(
						this.dados_civ.data_horas_voo_segundo,
						window.$sessao.getDateFormat()
					)
				)
			}
		},

		setaDadosOvn() {
			if (!this.isNil(this.dados_ovn)) {
				this.form.horas_inicial_ovn = this.dados_ovn.horas_inicial_ovn
				this.form.minutos_inicial_ovn = this.dados_ovn.minutos_inicial_ovn

				this.form.data_ultimo_voo_ovn = this._trataRetornoVazio(
					this._dateToDateSQL(
						this.dados_ovn.data_ultimo_voo_ovn,
						window.$sessao.getDateFormat()
					)
				)
			}
		},

		carregarVencimentos(id) {
			this.form.vencimentos = []
			if (!id) {
				return
			}
			this._axios(
				`/Licenca_documentacao/get_vencimentos_usuario/${id}`,
				'get',
				{
					callback: (retorno) => {
						if (retorno._request && retorno._status) {
							this.form.vencimentos = retorno.lista
						}
					}
				}
			)
		},

		/*setarLoginSenhaUsandoCPF(cpf) {
			this.$refs.acesso_sistema.setaLoginSenha(cpf)
		},*/

		formDadosCadastrais(itemParaSerGeradoForm) {
			this.dados_cadastrais = itemParaSerGeradoForm
		},

		dadosCIV(itemDadosCiv) {
			this.dados_civ = itemDadosCiv
		},

		dadosOVN(itemDadosOvn) {
			this.dados_ovn = itemDadosOvn
		},

		dadosAcessoSistema(dadosSistema) {
			this.dados_acesso_sistema = dadosSistema
		},

		setaAcessoSistema() {
			if (!this.isNil(this.dados_acesso_sistema)) {
				this.form.acesso_sistema = this._trataRetornoVazio(
					this.dados_acesso_sistema.acesso_sistema
				)
				this.form.assinatura = this._trataRetornoVazio(
					this.dados_acesso_sistema.assinatura
				)
				this.form.atualiza_assinatura = this._trataRetornoVazio(
					this.dados_acesso_sistema.atualiza_assinatura
				)
				this.form.atualiza_senha = this._trataRetornoVazio(
					this.dados_acesso_sistema.atualiza_senha
				)
				this.form.certificado_icp = this._trataRetornoVazio(
					this.dados_acesso_sistema.certificado_icp
				)
				this.form.id_perfil = this._trataRetornoVazio(
					this.dados_acesso_sistema.id_perfil
				)
				this.form.id_setor = this._trataRetornoVazio(
					this.dados_acesso_sistema.id_setor
				) 
				this.form.login = this._trataRetornoVazio(
					this.dados_acesso_sistema.login
				)
				if (!this.habilitaLogin && this.form.login === '' && this.form.cpf !== '') {
					this.form.login = this.form.cpf.replace(/\D/g, '')
				}
				this.form.perfis = this._trataRetornoVazio(
					this.dados_acesso_sistema.perfis
				)
				this.form.setores = this._trataRetornoVazio(
					this.dados_acesso_sistema.setores
				)
				this.form.senha = this._trataRetornoVazio(
					this.dados_acesso_sistema.senha
				)
				this.form.senha_icp = this._trataRetornoVazio(
					this.dados_acesso_sistema.senha_icp
				)
				this.form.matricula_prontos = this._trataRetornoVazio(
					this.dados_acesso_sistema.matricula_prontos
				)
			}
		},

		setaEnderecoResidencial() {
			if (!this.isNil(this.dadosForm.dados_endereco_residencial)) {
				this.form.bairro = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_residencial.bairro
				)
				this.form.cep = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_residencial.cep
				)
				this.form.cidade = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_residencial.cidade
				)
				this.form.complemento = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_residencial.complemento
				)
				this.form.estado = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_residencial.estado
				)
				this.form.logradouro = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_residencial.logradouro
				)
				this.form.numero = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_residencial.numero
				)
			}
		},

		setaEnderecoFuncional() {
			if (!this.isNil(this.dadosForm.dados_endereco_funcional)) {
				this.form.bairro_funcional = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_funcional.bairro
				)
				this.form.cep_funcional = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_funcional.cep
				)
				this.form.cidade_funcional = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_funcional.cidade
				)
				this.form.complemento_funcional = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_funcional.complemento
				)
				this.form.estado_funcional = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_funcional.estado
				)
				this.form.logradouro_funcional = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_funcional.logradouro
				)
				this.form.numero_funcional = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_funcional.numero
				)
			}
		},

		setaEnderecoEmergencial() {
			if (!this.isNil(this.dadosForm.dados_endereco_emergencial)) {
				this.form.bairro_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_emergencial.bairro
				)
				this.form.cep_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_emergencial.cep
				)
				this.form.cidade_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_emergencial.cidade
				)
				this.form.complemento_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_emergencial.complemento
				)
				this.form.estado_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_emergencial.estado
				)
				this.form.logradouro_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_emergencial.logradouro
				)
				this.form.numero_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_endereco_emergencial.numero
				)
			}
		},

		setaDadosAdicionais() {
			if (!this.isNil(this.dadosForm.dados_emergencia)) {
				this.form.alergia = this._trataRetornoVazio(
					this.dadosForm.dados_emergencia.alergia
				)
				this.form.fator_rh = this._trataRetornoVazio(
					this.dadosForm.dados_emergencia.fator_rh
				)
				this.form.tipo_sanguineo = this._trataRetornoVazio(
					this.dadosForm.dados_emergencia.tipo_sanguineo
				)
			}

			if (!this.isNil(this.dadosForm.dados_contato_emergencial)) {
				this.form.celular_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_contato_emergencial.celular_emergencia
				)
				this.form.grau_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_contato_emergencial.grau_emergencia
				)
				this.form.nome_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_contato_emergencial.nome_emergencia
				)
				this.form.telefone_emergencia = this._trataRetornoVazio(
					this.dadosForm.dados_contato_emergencial.telefone_emergencia
				)

				this.form.tipo = this._trataRetornoVazio(this.dadosForm.tipo)
			}

			if (!this.isNil(this.dadosForm.dados_adicionais)) {
				this.form.cargo = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.cargo
				)
				this.form.autoridade = this._trataRetornoVazio(this.dadosForm.dados_adicionais.autoridade)

				this.form.id_posto_graduacao = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.id_posto_graduacao
				)
				this.form.sgpe = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.sgpe
				)
				if (this._idCliente != 41 && this._idCliente != 38) {
					this.form.data_nascimento = this._trataRetornoVazio(
						this._dateToDateSQL(
							this.dadosForm.dados_adicionais.data_nascimento,
							window.$sessao.getDateFormat()
						)
					)
				} else {
					this.form.id_orgao = this._trataRetornoVazio(
						this.dadosForm.dados_adicionais.id_orgao
					)
					this.form.id_orgao_apoiado = this._trataRetornoVazio(
						this.dadosForm.dados_adicionais.id_orgao_apoiado
					)
				}
				this.form.masp = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.masp
				)
				this.form.nome_guerra = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.nome_guerra
				)
				this.form.identidade = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.identidade
				)
				this.form.matricula = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.matricula
				)
				this.form.numero_ordem = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.numero_ordem
				)
				this.form.estado_conselho = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.estado_conselho
				)
				this.form.num_registro = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.num_registro
				)
				this.form.banco = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.banco
				)
				this.form.codigo_banco = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.codigo_banco
				)
				this.form.codigo_agencia = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.codigo_agencia
				)
				this.form.numero_conta = this._trataRetornoVazio(
					this.dadosForm.dados_adicionais.numero_conta
				)

				let bases = this.dadosForm.dados_adicionais.base_contratual
				if (Array.isArray(bases)) {
					bases = bases.map((base) => {
						base.data = this._dateToDateSQL(
							base.data,
							window.$sessao.getDateFormat()
						)
						return base
					})
				}
				let funcoes = this.dadosForm.dados_adicionais.funcao
				if (Array.isArray(funcoes)) {
					funcoes = funcoes.map((funcao) => {
						funcao.data = this._dateToDateSQL(
							funcao.data,
							window.$sessao.getDateFormat()
						)
						return funcao
					})
				}

				this.form.base_contratual = this._trataRetornoVazio(bases)
				this.form.funcao = this._trataRetornoVazio(funcoes)
			}
		},

		modalDesativarUsuario() {
			this.$refs.desativar_usuario.carregaModal()
		},

		modalAtivarUsuario() {
			if (this.validaForm()) {
				this.$refs.ativar_usuario.carregaModalAtivar()
			} else {
				window.bus.$emit('exibir-notificacao', {
					text: this._traducao('global', 'favorPreencherCamposEmVermelho'),
					type: 'danger'
				})
			}
		},

		clickPrint() {
			this.setaDadosCadastrais()
			//this.setaDadosCiv()
			this.setaAcessoSistema()
			this.setaEnderecoResidencial()
			this.setaEnderecoFuncional()
			this.setaEnderecoEmergencial()
			this.setaDadosAdicionais()

			this.$refs.print.carregaForm(this.form)

			this.$nextTick(() => {
				this._print()
			})
		},

		clickSalvar() {
			if (this.validaForm()) {
				this.setaDadosCadastrais()
				///this.setaDadosCiv()
				this.setaDadosOvn()
				this.setaAcessoSistema()
				this.setaEnderecoResidencial()
				this.setaEnderecoFuncional()
				this.setaEnderecoEmergencial()
				this.setaDadosAdicionais()

				if (
					window.$cliente.get('id') == '9' ||
					window.$cliente.get('id') == '10' ||
					window.$cliente.get('id') == '18' ||
					window.$cliente.get('id') == '30' ||
					window.$cliente.get('id') == '33' ||
					window.$cliente.get('id') == '38' ||
					window.$cliente.get('id') == '41' ||
					window.$cliente.get('id') == '47' ||
					window.$cliente.get('id') == '50' ||
					window.$cliente.get('id') == '58' ||
					window.$cliente.get('id') == '60' ||
					window.$cliente.get('id') == '62' ||
					window.$cliente.get('id') == '65' ||
					window.$cliente.get('id') == '71'
				) {
					//verificando se é S
					if (this.form.tipo == 'S') {
						this.form.perfis = []
						this.form.perfis.push({
							id: $cliente.get('id_perfil_solicitante')
						})
					}
				}

				if (this.form.id == 0) {
					window.bus.$emit('load-in', {
						text: this._traducao('global', 'salvando')
					})
				} else {
					window.bus.$emit('load-in', {
						text: this._traducao('global', 'atualizando')
					})
				}

				this.$nextTick(() => {
					this.salvar()
				})
			} else {
				window.bus.$emit('exibir-notificacao', {
					text: this._traducao('global', 'favorPreencherCamposEmVermelho'),
					type: 'danger'
				})
			}
		},

		validaForm() {
			let passou = true

			if (!this.$refs.cadastro_usuario.validaForm()) {
				passou = false
			}

			if (!this.$refs.acesso_sistema.validaForm()) {
				passou = false
			}

			// VALIDAÇÃO DO FORMULÁRIO COMPLETO
			if (
				window.$cliente.get('id') == '1' ||
				window.$cliente.get('id') == '5' ||
				window.$cliente.get('id') == '8' ||
				window.$cliente.get('id') == '9' ||
				window.$cliente.get('id') == '10' ||
				window.$cliente.get('id') == '18' ||
				window.$cliente.get('id') == '25' ||
				window.$cliente.get('id') == '30' ||
				window.$cliente.get('id') == '33' ||
				window.$cliente.get('id') == '36' ||
				window.$cliente.get('id') == '38' ||
				window.$cliente.get('id') == '41' ||
				window.$cliente.get('id') == '43' ||
				window.$cliente.get('id') == '47' ||
				window.$cliente.get('id') == '50' ||
				window.$cliente.get('id') == '58' ||
				window.$cliente.get('id') == '60' ||
				window.$cliente.get('id') == '62' ||
				window.$cliente.get('id') == '65' ||
				window.$cliente.get('id') == '71'
			) {
				//  Tratamento de ERROR
				if (!this.$refs.usuario.validaForm()) {
					passou = false
				}

				//this.$refs.dados_civ.validaForm()

				if (this._getPrivilegio(332) && this.$refs.dados_ovn) {
					this.$refs.dados_ovn.validaForm()
				}
			}

			return passou
		},

		// ENVIA O FORMULÀRIO PARA O BACK
		salvar() {
			this._httpPost(
				'/Usuario/salvar',
				this.form,
				(retorno) => {
					window.bus.$emit('load-out')

					if (retorno._request && retorno._status) {
						if (window.$sessao.getId() == this.form.id) {
							window.$sessao.setFoto(this.form.foto)
						}

						if (this.menu == true) {
							window.bus.$emit('exibir-notificacao', {
								type: 'success',
								text: this._traducao('menuSolicitaApoio', 'dadosAtualizados')
							})
						}

						this.$emit('atualiza-lista', retorno.lista[0])
					} else {
						window.bus.$emit('exibir-notificacao', {
							type: 'danger',
							text:
								retorno.mensagem ||
								this._traducao('global', 'naoFoiPossivelCadastrarUsuario')
						})
					}
				},
				this.token
			)
		},
		carregaDados(token) {
			// Get Orgãos
			this._httpGet(
				'/Orgao/get_orgao',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.orgaos = retorno.lista
					}
				},
				token
			)

			// Get Perfil
			this._httpGet(
				'/Perfil/get',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.perfis = retorno.lista
					}
				},
				token
			)

			//get setores
			this._providerSetor((lista) => {
				this.setores = lista
			})

			// Get Postos/Graduação
			this._httpGet(
				'/Usuario/get_posto_graduacao',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.postos = retorno.lista
					}
				},
				token
			)

			this._httpGet(
				'/Base/get',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.bases = retorno.lista
					}
				},
				token
			)

			// Get Guarnição
			this._httpGet(
				'/Guarnicao/get_tipo_guarnicao',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.guarnicoes = retorno.lista
					}
				},
				token
			)

			// Get Cargo
			this._httpGet(
				'/Cargo/get_cargo',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.cargos = retorno.lista
					}
				},
				token
			)

			this._httpGet(
				'Funcao_bordo/listar',
				(retorno) => {
					if (retorno._request && retorno._status) {
						retorno.lista.map((item) => (item.excluir = 0))
						this.funcoes = retorno.lista
					}
				},
				token
			)

			this._httpGet(
				'/Fabricante/get',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.fabricantes = retorno.lista
					}
				},
				token
			)

			this._httpGet(
				`/Habilitacao/get`,
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.habilitacoes = retorno.lista
					}
				},
				token
			)

			this._httpGet(
				'Licenca/get',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.licencas = retorno.lista
					}
				},
				token
			)

			this._httpGet(
				'/Modelo/get',
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.modelos = retorno.lista
					}
				},
				token
			)
		}
	}
}
</script>